import { PATHS } from '@/routes/PATHS'
import { CoreLevelFeatureNames } from '@/services/types/permissions/permissionFeatures/mockCorePermissionFeature'
import { useCorePermissions } from '@/stores/permissions/permissions'
import { ThunderboltOutlined, UsergroupAddOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

export function useSettingsSidebarItems() {
  const { t } = useTranslation()
  const userManagementPermission = useCorePermissions(CoreLevelFeatureNames.userManagement)
  const hasUserManagementPermission = !!userManagementPermission?.edit

  const allItems = [
    {
      key: PATHS.accountConnectionsPage,
      label: t('sidebarItems.connections'),
      path: PATHS.accountConnectionsPage,
      icon: <ThunderboltOutlined />,
    },
    {
      key: PATHS.userManagementPage,
      label: t('sidebarItems.userManagement'),
      path: PATHS.userManagementPage,
      icon: <UsergroupAddOutlined />,
    },
  ]

  return allItems.filter((item) =>
    hasUserManagementPermission ? true : item.key !== PATHS.userManagementPage,
  )
}
